import { AssetFrontendVoiceCallsApi, PublicAssetFrontendApi$AssetComponentDto } from "@/custolink-transpiled_by_server/bc.asset_interaction.api_methods";
import { useQuery } from "@tanstack/react-query";
import useUiContext from "@/custolink-hooks/useUiContext";
import { useMemo } from "react";
import ReactMarkdown, { defaultUrlTransform } from "react-markdown";
import { useAssetFrontendDesign } from "@/custolink-views/asset_frontend/redesigns/assetFrontendDesign";

const urlTransform = (url: string) => {
  // Allow telephone links explicitly (React Markdown 9 does not allow telephone links by default)
  if (url.startsWith("tel:")) return url;
  // Keep the library’s default safety behavior for everything else
  return defaultUrlTransform(url);
};

// Shared with the classic design (both AssetViewClassic and AssetFrontendHome render this
// same component), so the markdown's typographic treatment follows the asset-frontend switch:
// classic visitors keep the old unstyled markdown, new-design visitors get the AI-chat-style
// `prose` treatment.
export default function VoiceCallAppPageComponent(p:{
  component: PublicAssetFrontendApi$AssetComponentDto,
}) {

  const uic = useUiContext()
  const newDesign = useAssetFrontendDesign()
  const req = useQuery({
    queryFn: () =>
      AssetFrontendVoiceCallsApi.getInfo(uic._orgId, p.component.id),
    queryKey: [
      "AssetFrontendVoiceCallsApi",
      AssetFrontendVoiceCallsApi.getInfo.name,
      uic._orgId,
      p.component.id,
    ],
  });

  const transformedText = useMemo(()=>{
    if(req.data?.text != null){
      const text = req.data?.text
      const result = text.replace(
        /\$\{icons:([^}]+)\}/g,
        (fullMatch: string, iconPath: string) => {
          // fullMatch === "${icons:flags/16x12/dk.png}"
          // iconPath  === "flags/16x12/dk.png"
          return "/server_assets/icons/"+iconPath
        }
      );
      return result
    }
    return null
  },[req.data?.text])

  // New design: same typographic treatment as the AI chat's markdown (Message.tsx's bubble:
  // `prose` over the design's own ink). Classic design: unstyled, as before this pass -
  // inherits whatever Ecme defaults ReactMarkdown produces.
  const markdownText = useMemo(()=>{
    if(transformedText != null) {
      if (newDesign) {
        return <div className="prose prose-sm max-w-none text-[var(--rda-on-surface)] [&_img]:inline-block [&_img]:align-middle [&_a]:text-[var(--rda-accent-text)] leading-[1.75]">
        <ReactMarkdown urlTransform={urlTransform}>
            {transformedText}
          </ReactMarkdown>
        </div>
      }
      return <div className="[&_img]:inline-block [&_img]:align-middle leading-[1.75]">
      <ReactMarkdown urlTransform={urlTransform}>
          {transformedText}
        </ReactMarkdown>
      </div>
    } else {
      return <></>
    }
  },[transformedText, newDesign])

  return <>
    {markdownText}
    </>
}

